import { create } from 'zustand';
import { AccountApi, type AccountEntity, ApiUtils, RequestStrategyEnum } from '@shared/api';

interface UseAccountsByCustomerStore {
  loading: boolean;
  data: AccountEntity[];
  datum: AccountEntity | null;
  error: string | null;
  getAccountsByCustomer: (request: { customerId: string; accountId?: string }, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useAccountsByCustomerStore = create<UseAccountsByCustomerStore>((set) => ({
  loading: false,
  datum: null,
  data: [],
  error: null,

  getAccountsByCustomer: ApiUtils.wrapperApi(async (request, signal) => {
    try {
      set({ loading: true, data: [], datum: null, error: null });
      const result = await AccountApi.getAccountsByCustomer(request.customerId, signal);
      const account = result.find((account) => account.accId.toString() === request.accountId);
      set({ loading: false, data: result || [], datum: account || null });
    } catch (error) {
      set({ loading: false, error: ApiUtils.getApiError(error) });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ loading: false, data: [], datum: null, error: null }),
}));
